import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import formatName from 'I18n/utils/formatName';
import ApprovalUnifiedEventStepContent from './ApprovalUnifiedEventStepContent';
import ApprovalUnifiedEventTimestamp from './ApprovalUnifiedEventTimestamp';
import ApprovalUnifiedEventNote from './ApprovalUnifiedEventNote';
import useUnifiedEventSubmittedUser from '../../hooks/useUnifiedEventSubmittedUser';
import useUnifiedEventApprovers from '../../hooks/useUnifiedEventApprovers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ApprovalUnifiedEventCreated(props) {
  const {
    event
  } = props;
  const requester = useUnifiedEventSubmittedUser(event);
  const approvers = useUnifiedEventApprovers(event);
  if (!requester) {
    return null;
  }
  const requesterName = formatName({
    firstName: requester.firstName,
    lastName: requester.lastName
  });
  const approversList = approvers.map(formatName).join(', ');
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "approval-unified-event-created",
    children: /*#__PURE__*/_jsxs(ApprovalUnifiedEventStepContent, {
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "productApprovals.unifiedEvents.ApprovalUnifiedEventCreated",
        options: {
          requesterName,
          approversList
        }
      }), /*#__PURE__*/_jsx(ApprovalUnifiedEventTimestamp, {
        event: event
      }), /*#__PURE__*/_jsx(ApprovalUnifiedEventNote, {
        event: event
      })]
    })
  });
}